<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col col="12" align="center" justify="center">
          <v-sheet class="neu-glow with-radius" max-width="460" min-width="360">
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12">
                  <div class="my-6 text-center">
                    <div class="text-h4 d-flex justify-center align-center">
                      <v-img
                        src="/static/fs/symbol-logo_fs_sinfondo.png"
                        lazy-src="/static/fs/symbol-logo_fs_sinfondo.png"
                        alt="Logo Futurespace"
                        max-width="50px"
                      ></v-img>
                      <span class="ml-3"><h4 class="primary--text">{{ $t('Global.Main.appName') }}</h4></span>
                    </div>
                  </div>
                  <v-sheet max-width="380" height="300" class="mx-auto" color="transparent">
                    <v-form
                      @submit.prevent="!validForm ? null : logHandler()"
                      ref="loginForm"
                    >
                      <v-text-field
                        autocomplete="off"
                        prepend-inner-icon="mdi-account"
                        v-model="form.username"
                        @input="validate"
                        :rules="userRules"
                        :label="$t('Global.Login.user')"
                        solo
                        flat
                      />
                      <v-text-field
                        autocomplete="off"
                        :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPwd ? 'text' : 'password'"
                        prepend-inner-icon="vpn_key"
                        v-model="form.password"
                        :rules="passRules"
                        :label="$t('Global.Login.pass')"
                        @input="validate"
                        @click:append="showPwd = !showPwd"
                        solo
                        flat
                      />
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <router-link
                          to="/forgot-password"
                          class="py-1 no-text-decoration"
                        >
                          {{ $t("Global.Login.forgotPass") }}
                        </router-link>
                      </div>
                      <v-btn class="mt-8" block type="submit" :disabled="!validForm">
                        {{ $t("Global.Login.access") }}
                      </v-btn>
                    </v-form>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-card-text>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AuthApi from "@/mixins/Services/AuthApi";
import DefsApi from "@/mixins/Services/DefsApi";
import loader from "@/mixins/Loader";
import UserInfoApi from "@/mixins/Services/UserInfoApi";
import Utils from "@/mixins/Utils";
import Logout from "@/mixins/Logout";

const defaultForm = {
  username: "",
  password: "",
  path: null,
  rememberMe: false,
};

export default {
  name: "Login",
  mixins: [AuthApi, UserInfoApi, DefsApi, loader, Utils, Logout],
  data() {
    return {
      form: Object.assign({}, defaultForm),
      userRules: [
        v => !!v || this.$t('Global.Login.requiredUser')
      ],
      passRules: [
        v => !!v || this.$t('Global.Login.requiredPass')
      ],
      showPwd: false,
      snackbar: false,
      isError: false,
      snackbarText: '',
      validForm: false
    };
  },
  computed: {
    ...mapGetters(["getMainView"])
  },
  methods: {
    ...mapActions(["setDataLogin", "setUser", "setSessionTime", "setDefsData"]),
    validate() {
      this.validForm = this.$refs.loginForm.validate();
    },
    logHandler() {
      this.setLoader(true);
      this.submit().then((r) => {
        if (r) {
          this.$emit('launch-snackbar', this.$t(`Global.Login.successSign`), 'success', "2000", 'mdi-check-circle');
          this.setLoader(false);
          this.$router.push({ name: this.getMainView });
        }
      });
    },
    async submit() {
      try {
        this.snackbar = false;
        const resp = await this.postLogin(this.form);
        this.setDataLogin(resp);
        const respUserInfo = await this.getUserInfo();
        this.setUser(respUserInfo);
        const defs = await this.getDefs();
        this.setDefsData(defs);
        return true;
      } catch (e) {
        this.resetForm();
        this.setLoader(false);
        if (this.isErrorText(e)) {
          const errorCode = this.getErrorText(e);
          this.$emit('launch-snackbar', this.$t(`Global.Error.c${errorCode}`), 'error', "4000", 'mdi-alert-octagon');
        }
        return false;
      }
    },
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.loginForm.reset();
    },
  },
  mounted() {
    // Puedes establecer valores iniciales aquí si es necesario
  },
};
</script>

<style scoped>
/* Aquí puedes añadir estilos específicos para el componente */
</style>
